import { render, staticRenderFns } from "./RelevanceAccount.vue?vue&type=template&id=2e41cdef&scoped=true"
import script from "./RelevanceAccount.vue?vue&type=script&lang=js"
export * from "./RelevanceAccount.vue?vue&type=script&lang=js"
import style0 from "./RelevanceAccount.vue?vue&type=style&index=0&id=2e41cdef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41cdef",
  null
  
)

export default component.exports